import { FreeBetsFromBackend } from 'app/api/services/freebets/types';

export function sortByAmountAndExpirationDate(freebets: FreeBetsFromBackend) {
  return freebets.sort((firstItem, secondItem) => {
    if (firstItem.amount === secondItem.amount){
      return firstItem.expireTimestamp < secondItem.expireTimestamp ? -1 : 1;
    }
    return firstItem.amount < secondItem.amount ? -1 : 1;
  });
}
